import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Check, Loader2, XCircle } from "lucide-react";
import { api, euro } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { metaPurchase } from "@/lib/pixel";

const TrackManSuccess = () => {
  const { lang } = useLang();
  const t = (de, en) => (lang === "de" ? de : en);
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("checking");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data: d } = await api.get(`/trackman/payments/status/${sid}`);
        setData(d);
        if (d.payment_status === "paid") {
          setState("ok");
          metaPurchase({ value: d.amount, currency: "EUR", bookingNumber: d.booking_number, contentName: "TrackMan-Hütte" });
          return;
        }
      } catch (_) {}
      tries += 1;
      if (tries < 8) setTimeout(poll, 1500); else setState("pending");
    };
    poll();
  }, [sid]);

  return (
    <div className="bg-[#050505] min-h-screen flex items-center justify-center px-4" data-testid="tm-success-page">
      <div className="max-w-md w-full bg-white text-black p-8 text-center border-t-4 border-[#ff0033]">
        {state === "checking" && (<><Loader2 size={40} className="animate-spin text-[#ff0033] mx-auto mb-4" /><p className="text-neutral-600">{t("Zahlung wird bestätigt…", "Confirming payment…")}</p></>)}
        {state === "ok" && (
          <>
            <div className="w-16 h-16 bg-green-500 rounded-full grid place-items-center mx-auto mb-5"><Check size={32} className="text-white" /></div>
            <h2 className="font-heading text-2xl uppercase tracking-tight">{t("Buchung bestätigt", "Booking confirmed")}</h2>
            <p className="text-neutral-600 mt-3">{t("Deine TrackMan-Buchung ist bezahlt und bestätigt.", "Your TrackMan booking is paid and confirmed.")}</p>
            <div className="bg-neutral-100 p-3 mt-4 text-sm text-left">
              <p>{t("Buchungsnummer", "Booking no.")}: <b>{data?.booking_number}</b></p>
              <p>{t("Datum", "Date")}: <b>{data?.date}</b> · {data?.start_time}–{data?.end_time}</p>
              <p>{t("Betrag", "Amount")}: <b>{euro(data?.amount || 0)}</b></p>
            </div>
            <p className="text-neutral-500 text-sm mt-4">{t("Bestätigung & Rechnung wurden an", "Confirmation & invoice sent to")} <b>{data?.email}</b>. {t("Der Zugangscode folgt separat vor Deiner Buchung.", "The access code follows separately before your booking.")}</p>
          </>
        )}
        {(state === "pending") && (<><Loader2 size={40} className="animate-spin text-[#ff0033] mx-auto mb-4" /><p className="text-neutral-600">{t("Deine Zahlung wird verarbeitet. Du erhältst in Kürze eine E-Mail-Bestätigung.", "Your payment is processing. You'll receive an email confirmation shortly.")}</p></>)}
        {state === "error" && (<><XCircle size={40} className="text-[#ff0033] mx-auto mb-4" /><p className="text-neutral-600">{t("Keine Buchung gefunden.", "No booking found.")}</p></>)}
        <Link to="/trackman" className="inline-block mt-6 bg-[#ff0033] text-white font-heading uppercase tracking-wider px-6 py-3 hover:bg-[#cc0029]">{t("Zurück zur Buchung", "Back to booking")}</Link>
      </div>
    </div>
  );
};

export default TrackManSuccess;
